import DownloadAppTool from './Components/Home/DownloadAppTool';
const ToolsData = [
    {
        title: 'editor',
        iconElement: 'md-edit',
        description: 'editorDescription',
        uri: '/category/edit',
        color: '#2D67B9',
        role: 'adminoreditor',
        online: true,
    },
    {
        title: 'library',
        iconElement: 'md-import-contacts',
        description: 'libraryDescription',
        uri: '/library',
        color: '#2D67B9',
        role: 'adminoreditor',
        online: true,
    },
    {
        title: 'users',
        iconElement: 'md-supervisor-account',
        description: 'usersDescription',
        uri: '/usermanagement',
        color: '#2D67B9',
        role: 'admin',
        online: true,
    },
    // {
    //     title: 'Platform Configuration',
    //     iconElement: 'md-build',
    //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    //     uri: '/configuration',
    //     color: '#0288D1',
    //     role: 'admin',
    // },
    {
        title: 'notifications',
        iconElement: 'md-notifications',
        description: 'notificationsDescription',
        uri: '/notifications',
        color: '#2D67B9',
        role: 'adminoreditor',
        online: true,
    },
    // {
    //     title: 'Forms',
    //     iconElement: 'md-speaker-notes',
    //     description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    //     uri: '/forms',
    //     color: '#00796B',
    //     role: 'admin',
    // },
    {
        title: 'shares',
        iconElement: 'md-share',
        description: 'sharesDescription',
        uri: '/shared',
        color: '#2D67B9',
        role: 'regularuser',
        online: true,
        etcSmartphone: true,
    },
    {
        title: 'visibilities',
        iconElement: 'md-security',
        description: 'sharesDescription',
        uri: '/visibilities',
        color: '#2D67B9',
        role: 'adminoreditor',
        online: true,
        etcSmartphone: true,
    },
    {
        title: 'analytics',
        iconElement: 'md-insert-chart',
        description: 'analyticsDescription',
        uri: '/analytics',
        color: '#66bb6a',
        role: 'admin',
        online: true,
    },
    {
        title: 'forms',
        iconElement: 'fa-wpforms',
        description: 'formsDescription',
        uri: '/forms',
        color: '#2D67B9',
        role: 'admin',
        online: true,
    },
    {
        title: 'publish',
        iconElement: 'md-playlist-add-check',
        description: 'publishDescription',
        uri: '/publish',
        color: '#2D67B9',
        role: 'adminoreditor',
        etcSmartphone: true,
        online: true,
    },
    {
        title: 'downloadApp',
        element: DownloadAppTool,
        uri: undefined,
        role: 'regularuser',
        online: true,
        etc: true,
    },
];

export default ToolsData;

export const ToolsDataPerPlatformId = (platformId) => {
    return ToolsData.filter((tool) => {
        if (
            tool.title === 'forms' &&
            platformId !== 'planacogida' &&
            platformId !== 'vallcompanys' &&
            platformId !== 'global' &&
            platformId !== 'brandhub'
        ) {
            return false;
        }
        return true;
    });
};
